import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const jsSdkToken = () => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'production') {
    return 'f50d99e111ce4219b10fd4c47407ce41'
  }

  return '8dd4e695a1b64816a69c4314d996493b'
}

export const getTaplyticsScript = () => {
  return `
  !function(){var t=window.Taplytics=window.Taplytics||[];if(window._tlq=window._tlq||[],!t.identify&&!t.loaded){t.loaded=!0,t.funcs=["init","identify","track","page","reset","propertiesLoaded","runningExperiments","variable","codeBlock"],t.mock=function(n){return function(){var e=Array.prototype.slice.call(arguments);return e.unshift(n),window._tlq.push(e),t}};for(var n=0;n<t.funcs.length;n++){var e=t.funcs[n];t[e]=t.mock(e)}t.load=function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src="//cdn.taplytics.com/taplytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)},t.load()}}();
  Taplytics.init("${jsSdkToken()}", {
    auto_page_view: false,
    user_bucketing: true,
  });
  Taplytics.propertiesLoaded(function(loaded) {
    Taplytics.runningExperiments(function(data) {
      Object.entries(data).forEach(function(experiment) {
        var key = experiment[0];
        var value = experiment[1];
        analytics.group(key, { variation: value } );
      });
    });
  });
  `
}

export const identifyUser = (userId?: string, email?: string) => {
  if (userId && email) {
    window.Taplytics.identify({ user_id: userId, email: email })
  }
}

declare global {
  interface Window {
    Taplytics: any
  }
}
